"use strict";

exports.__esModule = true;
var HTML5NamedCharRefs = {
    // We don't need the complete named character reference because linkifyHtml
    // does not modify the escape sequences. We do need &nbsp; so that
    // whitespace is parsed properly. Other types of whitespace should already
    // be accounted for
    nbsp: "\xA0"
};
exports.default = HTML5NamedCharRefs;


//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/lib/simple-html-tokenizer/html5-named-char-refs.js
// module id = 31
// module chunks = 0 1